module.exports = __webpack_public_path__ + "img/vip2.116de79f.png";